"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CoresIdentidadeMU;
(function (CoresIdentidadeMU) {
    CoresIdentidadeMU["azulMu"] = "#43A4D1";
    CoresIdentidadeMU["azulEscuroMu"] = "#073654";
    CoresIdentidadeMU["laranjaMu"] = "#F4762A";
    CoresIdentidadeMU["brancoMu"] = "#FDFDFD";
    CoresIdentidadeMU["cinzaMu"] = "#646363";
})(CoresIdentidadeMU || (CoresIdentidadeMU = {}));
;
exports.default = CoresIdentidadeMU;
